import React from "react";
import "./i18nextInit";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { createCookie, readCookie } from "./utils/helpers";
import { getUserObject } from "./pages/sign-up/actions";
import { userStore } from "./utils/signals";

(function sanitizeInitialUrl() {
  const { pathname, search, hash } = window.location;
  const cleanedPath = pathname.replace(/\/{2,}/g, "/");

  if (cleanedPath !== pathname) {
    window.history.replaceState(null, "", cleanedPath + search + hash);
  }
})();

if (!!readCookie("jwtToken")) {
  getUserObject().then((response) => {
    createCookie("jwtToken", readCookie("jwtToken"), 1);
  });
}
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
